import { render, staticRenderFns } from "./MoveFolderModal.vue?vue&type=template&id=03fe1791"
import script from "./MoveFolderModal.vue?vue&type=script&lang=js"
export * from "./MoveFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports